import { Button } from '@diamond-design/components';
import styles from './ctaButton.module.scss';

export default function CtaButton({
  className = '',
  variant = 'primary',
  size = 'lg',
  // eslint-disable-next-line no-unused-vars
  color,
  // eslint-disable-next-line no-unused-vars
  textTransform,
  // eslint-disable-next-line no-unused-vars
  defaultColor,
  ...props
}) {
  const variantToDds = {
    primary: 'primary',
    secondary: 'secondary',
    'secondary white': 'secondary',
    'secondary gradient': 'secondary',
    'secondary dark': 'secondary',
    'primary white': 'primary',
    link: 'link',
  };

  const variantToStyle = {
    primary: styles.primary,
    secondary: styles.secondary,
    'secondary white': styles.secondaryWhite,
    'secondary gradient': styles.secondaryGradient,
    'secondary dark': styles.secondaryDark,
    'primary white': styles.primaryWhite,
    link: styles.link,
  };

  const normalizedVariant = variant?.toLowerCase().trim() || 'primary';
  const ddsVariant = variantToDds[normalizedVariant] || variantToDds.primary;
  const variantClass =
    variantToStyle[normalizedVariant] || variantToStyle[ddsVariant] || '';

  return (
    <Button
      className={`${styles.button} ${variantClass} ${className}`}
      variant={ddsVariant}
      size={size}
      {...props}
    />
  );
}
